var map = {
	"./scisa__Autorizar_Portafolios.svg": 43345,
	"./scisa__Clientes.svg": 73090,
	"./scisa__Divisas.svg": 52048,
	"./scisa__Mesa_de_cambios.svg": 40640,
	"./scisa__Operaciones.svg": 40107,
	"./scisa__Precios.svg": 97180,
	"./scisa__Tesoreria.svg": 44669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44052;